var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.278,
    height: 14.257,
    viewBox: "0 0 14.278 14.257",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_638",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 638",
    transform: "translate(-309.859 -390.865)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u9577\\u65B9\\u5F62_1614",
    "data-name": "\\u9577\\u65B9\\u5F62 1614",
    d: "M1.425,14.247,0,12.822,12.822,0l1.425,1.425Z",
    transform: "translate(309.859 390.875)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u9577\\u65B9\\u5F62_1615",
    "data-name": "\\u9577\\u65B9\\u5F62 1615",
    d: "M14.247,12.822l-1.425,1.425L0,1.425,1.425,0Z",
    transform: "translate(309.89 390.865)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.37220293b025cce12766b5b26f160d32.svg";
export { ForwardRef as ReactComponent };